module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/images/reviews_bg-9c24e885c86fbce2b2aa9680437e07ef.jpg";